import { createContext, useContext } from 'react';

const WorkoutProgressContext = createContext(null);

export function useWorkoutProgress() {
  const ctx = useContext(WorkoutProgressContext);
  if (!ctx) throw new Error('useWorkoutProgress must be used within WorkoutSessionProvider');
  return ctx;
}

export default WorkoutProgressContext;
